export const baseUrl = "https://app.tekorero.com/api/v2.0"
export const loginUrl = "https://app.tekorero.com"

// export const baseUrl = "http://192.168.43.3:3000/api/v2.0"

// export const loginUrl = "http://localhost:3000"
